export enum Plan {
  ENTERPRISE = 'enterprise',
  PRO = 'pro',
  FREE = 'free',
  BASE = 'base',
  CORE = 'core',
  HUB = 'hub',
  GRID = 'grid',
}

export const EnterprisePlans = [Plan.ENTERPRISE, Plan.BASE, Plan.GRID, Plan.CORE, Plan.HUB] as const;
